<template>
    <el-row class="mx-2 mt-4">
        <div class="col-12">
            <div class="mb-2 text-black">
                To get started, please install the Aloware Cloud Contact Center Package in Salesforce to enable
                calls, track data, and use all integration features. Then authenticate Salesforce in Aloware to
                complete the setup.
            </div>
            <div class="d-flex">
                <el-tooltip
                    class="item"
                    effect="dark">
                    <div slot="content">
                        Please install the Aloware Cloud Contact Center Package in Salesforce to enable calling,
                        track call data, and access all integration features.
                    </div>
                    <el-button type="primary"
                               size="mini"
                               @click="openSalesforcePackage"
                               class="mr-2">
                        Install Salesforce Package
                    </el-button>
                </el-tooltip>
                <el-tooltip
                    class="item"
                    effect="dark"
                    placement="right">
                    <div slot="content">
                        <strong>Authentication</strong>
                        <br>
                        <small>
                            This will redirect you to Salesforce for authentication.
                        </small>
                    </div>
                    <el-button plain
                               size="mini"
                               @click="oauth()">
                        <span>Installed. Authenticate</span>
                        <i class="fa fa-sign-in mr-2"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
    </el-row>
</template>
<script>
export default {
    data() {
        return {
            salesforce_version: {
                loading: false,
                need_install: false,
                need_to_update: false,
                available_version: null,
                installed_version: null
            }
        }
    },
    props: {
        integrationName: {
            type: String,
            required: true
        },
        card: {
            type: Object,
            required: true
        },
        oauth: {
            type: Function,
            required: true
        },
    },
    methods: {
        openSalesforcePackage() {
            window.open('https://appexchange.salesforce.com/appxListingDetail?listingId=c6e09820-12d5-48f4-aa9f-3c485d3781b6', '_blank')
        },
    }
}
</script>
